import { Controller } from '@hotwired/stimulus'

// Las tres pantallas de la ficha de escuela (ENH-RNK-5363): Información, Programas y
// Profesorado.
//
// Cuál se ve la decide el servidor con `?pantalla=`, que es lo que hace que la pestaña se
// pueda compartir, que funcione sin JavaScript y que sobreviva al filtrado del buscador —que
// reenvía su formulario—. Este controlador solo evita el viaje al servidor cuando alguien
// cambia de pestaña: las tres pantallas ya están servidas en el HTML, así que basta con
// enseñar la que toca y dejar la URL como si hubiéramos navegado.
const ACTIVA_PANTALLA = 'rnk-Escuelas_Pantalla-activa'
const ACTIVA_ENLACE = 'rnk-Escuelas_NavEnlace-activo'

export default class extends Controller {
  static targets = ['barra', 'enlace', 'pantalla']

  connect () {
    this.alVolver = () => this.mostrar(this.pantallaDeLaUrl, { escribirUrl: false })
    window.addEventListener('popstate', this.alVolver)
  }

  disconnect () {
    window.removeEventListener('popstate', this.alVolver)
  }

  cambiar (evento) {
    // Sin `preventDefault` el enlace navegaría igual: es un enlace de verdad para que siga
    // funcionando sin JavaScript y para que se pueda abrir en otra pestaña.
    evento.preventDefault()
    this.mostrar(evento.currentTarget.dataset.pantalla, { url: evento.currentTarget.href })
  }

  mostrar (clave, { url = null, escribirUrl = true } = {}) {
    const pantalla = this.pantallaTargets.find((nodo) => nodo.dataset.pantalla === clave)
    if (!pantalla) return

    this.pantallaTargets.forEach((nodo) => nodo.classList.toggle(ACTIVA_PANTALLA, nodo === pantalla))
    this.enlaceTargets.forEach((nodo) => nodo.classList.toggle(ACTIVA_ENLACE, nodo.dataset.pantalla === clave))
    // Se sube hasta la barra de pestañas, que es donde empieza la pantalla nueva: sin
    // desplazar nada, el «Ver los N programas» de la cabecera cambiaba de pantalla sin que
    // se viera —el visitante se queda mirando la cabecera y parece que no ha pasado nada—.
    //
    // Hasta la barra y no hasta `this.element`, que es el elemento del controlador y envuelve
    // también la cabecera —tiene que hacerlo, porque ese enlace cuelga de ella—, así que subir
    // a su principio era subir al principio de la página entera. Señalado por diseño el
    // 22-sep-2026.
    this.barraTarget.scrollIntoView({ block: 'start' })

    if (escribirUrl && url) window.history.pushState({}, '', url)
  }

  get pantallaDeLaUrl () {
    const pedida = new URLSearchParams(window.location.search).get('pantalla')
    const existe = this.pantallaTargets.some((nodo) => nodo.dataset.pantalla === pedida)

    return existe ? pedida : this.pantallaTargets[0]?.dataset.pantalla
  }
}
